import F from '../../commons/HTTPFetcher';
import * as ContentTypes from '../../commons/constants/HTTPContentTypes';
import {
  FAILURE_UPDATE_USER_COLUMNS_SETTINGS_ACTION,
  PENDING_UPDATE_USER_COLUMNS_SETTINGS_ACTION,
  SUCCESS_UPDATE_USER_COLUMNS_SETTINGS_ACTION,
  RESET_UPDATE_USER_COLUMNS_SETTINGS_ACTION,
  PENDING_DELETE_USER_COLUMNS_SETTINGS_ACTION,
  FAILURE_DELETE_USER_COLUMNS_SETTINGS_ACTION,
  SUCCESS_DELETE_USER_COLUMNS_SETTINGS_ACTION,
  RESET_DELETE_USER_COLUMNS_SETTINGS_ACTION
} from '../actionsTypes';
import { AUTHENTICATION_STORAGE_KEY } from './auth';

export const updateUserColumnsSettings = ({ columnSetting, category }) => async (dispatch) => {
  dispatch(updateUserColumnsSettingsStart());

  try {
    const url = `/me/columns/${category}`;

    await F.put(url, {
      body: columnSetting,
      contentType: ContentTypes.JSON
    });

    const currentUser = JSON.parse(localStorage.getItem(AUTHENTICATION_STORAGE_KEY));
    localStorage.setItem(
      AUTHENTICATION_STORAGE_KEY,
      JSON.stringify({
        ...currentUser,
        columnSetting: {
          ...currentUser.columnSetting,
          [category]: columnSetting
        }
      })
    );

    return dispatch(updateUserColumnsSettingsSucceeded({ columnSetting, category }));
  } catch (errors) {
    dispatch(updateUserColumnsSettingsFailure({ errors }));

    throw errors;
  }
};

const updateUserColumnsSettingsStart = () => ({
  type: PENDING_UPDATE_USER_COLUMNS_SETTINGS_ACTION
});

const updateUserColumnsSettingsSucceeded = ({ columnSetting, category }) => ({
  type: SUCCESS_UPDATE_USER_COLUMNS_SETTINGS_ACTION,
  payload: {
    columnSetting,
    category
  }
});

const updateUserColumnsSettingsFailure = (errors) => ({
  type: FAILURE_UPDATE_USER_COLUMNS_SETTINGS_ACTION,
  payload: {
    errors
  }
});

export const resetUpdateUserColumnsSettings = () => ({
  type: RESET_UPDATE_USER_COLUMNS_SETTINGS_ACTION
});

export const deleteUserColumnsSettings = ({ columnSetting, category }) => async (dispatch) => {
  dispatch(deleteUserColumnsSettingsStart());

  try {
    const url = `/me/columns/${category}`;

    await F.delete(url);

    const currentUser = JSON.parse(localStorage.getItem(AUTHENTICATION_STORAGE_KEY));

    delete currentUser.columnSetting[category];

    localStorage.setItem(AUTHENTICATION_STORAGE_KEY, JSON.stringify(currentUser));

    return dispatch(deleteUserColumnsSettingsSucceeded({ columnSetting, category }));
  } catch (errors) {
    dispatch(deleteUserColumnsSettingsFailure({ errors }));

    throw errors;
  }
};

const deleteUserColumnsSettingsStart = () => ({
  type: PENDING_DELETE_USER_COLUMNS_SETTINGS_ACTION
});

const deleteUserColumnsSettingsSucceeded = ({ columnSetting, category }) => ({
  type: SUCCESS_DELETE_USER_COLUMNS_SETTINGS_ACTION,
  payload: {
    columnSetting,
    category
  }
});

const deleteUserColumnsSettingsFailure = (errors) => ({
  type: FAILURE_DELETE_USER_COLUMNS_SETTINGS_ACTION,
  payload: {
    errors
  }
});

export const resetDeleteUserColumnsSettings = () => ({
  type: RESET_DELETE_USER_COLUMNS_SETTINGS_ACTION
});
